import { render } from "./PlayerJoinWaitBox.vue?vue&type=template&id=36498f14"
import script from "./PlayerJoinWaitBox.vue?vue&type=script&lang=js"
export * from "./PlayerJoinWaitBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__